import { Inject, Injectable } from '@angular/core';

import { SESSION_ID } from '@cigna/shared/angular/core/interfaces-util';
import { LocalStorageService } from '@cigna/shared/angular/core/local-storage-util';

export const SESSION_STORAGE_KEY = 'sessionId';
export enum ClaimsSessionVariables {
  paidClaims = 'claims-summary-paid-claims',
  claimsPayInfo = 'claims-pay-info',
  ClaimDetailInfo = 'claims-detail-info',
  storageExpanded = 'claims-summary-storage-expanded',
  selectedCoveragePeriod = 'claims-summary-selected-coverage-period',
  selectedMemberIndex = 'claims-summary-selected-family-member',
  selectedProductIndex = 'claims-summary-selected-product',
  JPMC_FORCED_MODAL_KEY = 'jpmc_forced_modal_key',
}

@Injectable({ providedIn: 'root' })
export class UserSessionStorageService {
  constructor(
    private _localStorageService: LocalStorageService,
    @Inject(SESSION_ID) private _sessionId: string,
  ) {}

  get(key: string, sessionId?: string) {
    try {
      const item = JSON.parse(this._localStorageService.get(key) || 'null');
      if (
        !item ||
        item[SESSION_STORAGE_KEY] !== (sessionId ? sessionId : this._sessionId)
      ) {
        this.delete(key);
        return null;
      }
      return item.value;
    } catch {
      console.error('Cannot parse object from LocalStorage.');
      return null;
    }
  }

  put(key: string, value: string | number | {}, sessionId?: string) {
    this._localStorageService.put(
      key,
      JSON.stringify({
        value,
        [SESSION_STORAGE_KEY]: sessionId ? sessionId : this._sessionId,
      }),
    );
  }

  delete(key: string) {
    this._localStorageService.delete(key);
  }

  clearClaimsStoredKeys() {
    Object.values(ClaimsSessionVariables).forEach((value) => {
      this.delete(value);
    });
  }
}
